import { Sentry } from '@/components/Sentry';
import { NarrativeFairValueModal } from '@/components/NarrativeFairValue';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  companyId: string;
};

export const WatchlistNarrativeFairValueModal = ({
  isOpen,
  onClose,
  companyId,
}: Props) => {
  return (
    <Sentry sentryCapture={{ team: 'narwhals' }} globalDisabled>
      <NarrativeFairValueModal
        isModalOpen={isOpen}
        onClose={onClose}
        companyId={companyId}
      />
    </Sentry>
  );
};
